import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
import withLayout from '../../hocs/Layout'
import {Box, Grid,  Alert} from '@mui/material'
import {FormProvider, RHFTextField} from '../../common/hook-form'
import {LoadingButton} from '@mui/lab'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {apiConstants, getGeneric} from '../../common/constants'
import {downloadCSV} from '../../helpers/UtilityHelper'
import PageTitle from '../../common/PageTitle'
import {getMerchant} from '../../helpers/ReduxHelpers'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {FONT} from '../../styles/foundation/typography'
import { BORDER, LIGHT_BG, WHITE, PRIMARY_BLUE} from '../../styles/foundation/colors'

const pageSx = {fontFamily: FONT, p: {xs: 1.5, md: 2.5}, bgcolor: LIGHT_BG, minHeight: '100vh'}

const cardSx = {bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', p: 3}
const downloadBtnSx = {
  fontFamily: FONT, textTransform: 'none', borderRadius: '10px', bgcolor: PRIMARY_BLUE,
  px: 3, py: 1.2, fontSize: '0.9rem', fontWeight: 600,
}

const ZoneMapping = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const merchant = getMerchant()
  const merchantId = merchant?.id || ''
  // Vertical split (set per menu entry): B2C = D2C, B2B = PTL
  const freightType = props.freightType || 'B2C'
  const isB2B = freightType === 'B2B'
  const vLabel = isB2B ? 'PTL' : 'D2C'

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({
      fromPincode: Yup.string().required('PIN code is required').matches(/^[1-9][0-9]{5}$/, 'Enter a valid 6-digit PIN code'),
    })),
    defaultValues: {fromPincode: ''},
  })

  const download = async (fromPincode) => {
    setIsLoading(true)
    try {
      const data = await getGeneric(`${apiConstants.FETCH_ZONE_MAPPING}?fromPincode=${fromPincode}&merchantOid=${merchantId}&shipmentType=${freightType}`)
      downloadCSV(data?.data, `zone-mapping-${vLabel.toLowerCase()}.csv`)
    } catch (e) { console.error(e) }
    setIsLoading(false)
  }

  // B2C downloads zones FROM a source PIN; B2B (PTL) returns the full per-PIN B2B zone map,
  // so the backend ignores fromPincode — send a placeholder just to satisfy the param.
  const onSubmit = (val) => download(val.fromPincode)
  const onDownloadB2B = () => download('000000')
  let subTitle =  isB2B
    ? 'Download the full PTL zone classification for every serviceable PIN code'
    : 'Download zone classification for all delivery PIN codes from a given source PIN code';
  return (
    <Box sx={pageSx}>
      <PageTitle subTitle={subTitle}>{vLabel} Zone Mapping</PageTitle>
      {/* <Box sx={heroSx}>
        <Typography sx={{color: WHITE, fontWeight: 700, fontSize: '1.3rem', fontFamily: FONT, mb: 0.3, position: 'relative', zIndex: 1}}>{vLabel} Zone Mapping Download</Typography>
        <Typography sx={{color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', fontFamily: FONT, position: 'relative', zIndex: 1}}>
         }
        </Typography>
      </Box> */}

      <Box sx={cardSx}>
        {isB2B ? (
          <>
            <Alert severity='info' icon={<InfoOutlinedIcon />} sx={{borderRadius: '10px', mb: 2.5, fontFamily: FONT, fontSize: '0.82rem'}}>
              Download a CSV of the complete PTL (B2B) zone mapping — the zone (Local, Regional, Metro, ROI, Special)
              for every serviceable PIN code. PTL zones are defined per PIN code, so no source PIN is needed.
            </Alert>
            <LoadingButton loading={isLoading} onClick={onDownloadB2B} variant='contained' startIcon={<DownloadOutlinedIcon />} sx={downloadBtnSx}>
              Download PTL Zone Mapping
            </LoadingButton>
          </>
        ) : (
          <>
            <Alert severity='info' icon={<InfoOutlinedIcon />} sx={{borderRadius: '10px', mb: 2.5, fontFamily: FONT, fontSize: '0.82rem'}}>
              Enter your pickup (source) PIN code to download a CSV showing zone classification (Local, Regional, Metro, ROI, Special)
              for every serviceable delivery PIN code. Useful for rate estimation and zone-based pricing analysis.
            </Alert>
            <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
              <Grid container spacing={2} alignItems='flex-end'>
                <Grid item xs={12} sm={4}>
                  <RHFTextField name='fromPincode' label='Source PIN Code' placeholder='e.g., 400001' size='medium' />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <LoadingButton loading={isLoading} type='submit' variant='contained' startIcon={<DownloadOutlinedIcon />} sx={downloadBtnSx}>
                    Download Zone Mapping
                  </LoadingButton>
                </Grid>
              </Grid>
            </FormProvider>
          </>
        )}
      </Box>
    </Box>
  )
}

export default withLayout(ZoneMapping)
